import type { IAnalyticsProvider, ExpaiEvent } from './types';
import { NoopProvider } from './noop_provider';

let _provider: IAnalyticsProvider | null = null;

export async function initAnalytics(): Promise<IAnalyticsProvider> {
  if (_provider) return _provider;
  const key = (import.meta as any).env?.VITE_POSTHOG_KEY as string | undefined;
  const host = ((import.meta as any).env?.VITE_POSTHOG_HOST as string | undefined) ?? 'https://eu.i.posthog.com';
  if (key) {
    try {
      const { PostHogProvider } = await import('./posthog_provider');
      _provider = new PostHogProvider(key, host);
    } catch {
      _provider = new NoopProvider();
    }
  } else {
    _provider = new NoopProvider();
  }
  return _provider;
}

export function getAnalytics(): IAnalyticsProvider {
  if (!_provider) _provider = new NoopProvider();
  return _provider;
}

export function isPostHogActive(): boolean {
  return Boolean((import.meta as any).env?.VITE_POSTHOG_KEY);
}

export const track = (event: ExpaiEvent, props?: Record<string, unknown>) =>
  getAnalytics().trackEvent(event, props);

export const identify = (userId: string, traits?: Record<string, unknown>) =>
  getAnalytics().identifyUser(userId, traits);

export const resetAnalyticsUser = () => getAnalytics().resetUser();

export const pageView = (path: string) => getAnalytics().pageView(path);

export type { IAnalyticsProvider, ExpaiEvent } from './types';
